<div class="w-full">
  <input type="text" [class]="styleClass()" pInputText [formControl]="controlName()" appNumberFormat 
  [placeholder]="placeholder()" [conditionToFormat]="conditionToFormat()" [mode]="mode()" [maxlength]="maxlength()"
  [maxFractionDigits]="maxFractionDigits()"
  (blur)="onBlurEvent($event)"
   />
</div>
